import {
    Component,
    OnInit,
    AfterViewInit,
    ViewEncapsulation,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef,
    effect} from '@angular/core';
import {
    UntypedFormArray,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import {
    PopupConfig,
    PopupService,
    PopupType,
    SpinnerService,
    UserProfileObject,
} from 'merlin-library';
import { EnrollFollowupScheduleService } from '../../services/enroll-followup-schedule.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { DateTimeService } from './date-time.service';
import { HttpClient } from '@angular/common/http';

import { MessageDataService } from './messageDate.service';
import { UserService } from 'merlin-library';
import { MatDialog } from '@angular/material/dialog';

import { ViewPrintFollowupComponent } from '../view-print-followup/view-print-followup.component';

import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LocalizationService, ReturnType } from 'src/core/utilitites/localization.service';
import { PatientListService } from '../../services/patient-list.service';
import { ReleasePatientDialogComponent } from '../../release-patient-dialog/release-patient-dialog.component';
import { HelperService, IdentifierService, ToasterClass } from 'merlin-core';
import { GlobalInputSecurityService } from 'src/core/utilitites/global-input-security.service';
import { EnrollPatientDeviceDataService } from '../../services/enroll-patient-device-data.service';
import { FunctionMode } from '../enums/enroll-patient.enum';
import { SchdMethodCodes } from '../../followup-schedule/followup-schedule.model';
import moment, { invalid } from 'moment-timezone';
import { PatientTransferRequestClinicService } from '../../services/patient-transfer-request-clinic.service';
import { PatientProfilePrintDialogComponent } from '../../patient-profile-print-dialog/patient-profile-print-dialog.component';
import {
    debounceTime,
    distinctUntilChanged,
} from 'rxjs/operators';

import { SmartFollowupComponent } from './smart-followup/smart-followup.component';
import { CustDateAdapter } from '../../followup-schedule/Calender';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MyFormat } from './date-format/my-date-format';
export const PICK_FORMATS = {
    parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
    display: {
        dateInput: 'input',
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    },
};

export const LOCALIZATION_LABEL = {
    'perm.startDate': 'label.gb.starting_on',
    'temp.durationCd': 'label.gb.transmit_every',
    'temp.frequencyCd': 'label.gb.for'
};

@Component({
    selector: 'app-followup-schedule',
    templateUrl: './followup-schedule.component.html',
    styleUrls: ['./followup-schedule.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        DatePipe,
        {
            provide: DateAdapter,
            useClass: CustDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MyFormat },
    ],
    standalone: false
})
export class FollowupScheduleComponent implements OnInit, AfterViewInit {
    @ViewChild(SmartFollowupComponent) smartFollowUpComponent: SmartFollowupComponent;
    @Input('patientid') patiendIdToSearch: string;
    @Input('functionMode') functionMode: string;
    @Input() isActiveStep: boolean = true;
    @Output() navForward = new EventEmitter<string>();
    @Output() navBackward = new EventEmitter<string>();
    userProfileSubscription: any;
    displayMode: string = 'view';
    isAveirDevice: boolean = true;
    dataLoaded: boolean = false;
    displayError: boolean = false;
    errorData: any = {};
    errorText: string = '';

    scheduleMode: string = '509';
    permScheduleCalc: string = 'true';
    tempScheduleCalc: string = 'true';

    patientData: any = {};
    originalData: any = {};
    dataToSend: any = {};
    messages: any = {};
    userProfData: any = {};
    datePlaceholder: string = '';

    permStartDate = new UntypedFormControl('', [Validators.required]);

    form: UntypedFormGroup;

    isSP2CanEnroll: boolean;
    patRes;
    isPatientRelease: boolean = false;
    releasePatientMsg: string;
    toastRef;
    formValidators = {
        'perm.startDate': new UntypedFormControl(this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ), [Validators.required]),
        'perm.transmitOnDayCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'perm.transmitOnWeekCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'perm.transmitOnMonthCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'perm.durationCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'perm.frequencyCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),

        'temp.startDate': new UntypedFormControl(this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ), [Validators.required]),
        'temp.transmitOnDayCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'temp.transmitOnWeekCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'temp.transmitOnMonthCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'temp.durationCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'temp.frequencyCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
    };

    activeValidators = {
        'perm.startDate': new UntypedFormControl(this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ), [Validators.required]),
        'perm.transmitOnDayCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'perm.transmitOnWeekCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'perm.transmitOnMonthCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'perm.durationCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'perm.frequencyCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),

        'temp.startDate': new UntypedFormControl(this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ), [Validators.required]),
        'temp.transmitOnDayCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'temp.transmitOnWeekCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'temp.transmitOnMonthCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'temp.durationCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
        'temp.frequencyCd': new UntypedFormControl('', [
            Validators.required,
            Validators.min(1),
        ]),
    };

    formKeys = [
        'perm.startDate',
        'perm.transmitOnDayCd',
        'perm.transmitOnWeekCd',
        'perm.transmitOnMonthCd',
        'perm.durationCd',
        'perm.frequencyCd',
        'temp.startDate',
        'temp.transmitOnDayCd',
        'temp.transmitOnWeekCd',
        'temp.transmitOnMonthCd',
        'temp.durationCd',
        'temp.frequencyCd',
    ];
    legalJurisdiction: string;
    hasPatientDataEntryAccess: boolean;
    followupScheduleForm: UntypedFormGroup;
    schdMethodCodes: SchdMethodCodes[];
    lastTransMissionDate: string;
    showReminderMsg: boolean;
    deviceInductive: boolean = false;
    directCallFlg: boolean = false;
    patTxSettingsForm: UntypedFormGroup;
    followupCapableFlg: boolean;
    stCapableFlg: boolean;
    isExistingManualDateChange: boolean = false;
    orginalManualDates: string[] = ["", "", "", "", "", ""];
    activatorClinicFlg: boolean = false;


    public stringLabels = [
        "label.gb.follow_sched",
        "label.gb.edit",
        "label.gb.button_cancel",
        "label.gb.save",
        "label.gb.print_profile",
        "label.gb.release_patient",
        "label.gb.more_actions",
        "label.gb.reactivate_pat",
        "label.gb.scheduling_method",
        "label.gb.view_schedule",
        "msg.gb.manual_sched_prompt",
        "label.gb.clear",
        "label.gb.remove_overrides",
        "label.gb.stored_egms",
        "label.gb.stat_diags",
        "label.gb.episodes",
        "label.gb.clear_icm_diag_epi_segm",
        "label.gb.st_monitoring",
        "label.gb.epis_incl_SEGM",
        "label.gb.diagnostics",
        "label.gb.override_instr_text",
        "label.gb.back",
        "label.gb.saveandclose",
        "label.gb.continue",
        "label.gb.required_field"
    ]

    public labels: Record<string, string>;

    noScheduledTransmissionHtml: string;
    permStartDateString: string = '';
    tempStartDateString: string = '';

    constructor(
        private followupService: EnrollFollowupScheduleService,
        private spinnerService: SpinnerService,
        private datePipe: DatePipe,
        private dateFormatService: DateTimeService,
        private router: Router,
        private httpClient: HttpClient,
        private messageDataService: MessageDataService,
        private userService: UserService,
        public dialog: MatDialog,
        private translateService: TranslateService,
        private toastrSer: ToastrService,
        public localizationService: LocalizationService,
        public patientListService: PatientListService,
        public helperService: HelperService,
        public identifierService: IdentifierService,
        private popupService: PopupService,
        private enrollService: EnrollPatientDeviceDataService,
        private fb: UntypedFormBuilder,
        private toastService: ToastrService,
        private requestService: PatientTransferRequestClinicService,
        private elementRef: ElementRef,
        private globalInputSecurity: GlobalInputSecurityService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
         this.followupScheduleForm = this.fb.group({
            discSchedule: this.createManualScheduleForm(),
            schedulingMethodCd: new UntypedFormControl(''),
            smartSchedule: this.createSmartScheduleForm(),
            identifyKeyEpisodesCheckboxValue: new UntypedFormControl(''),
            otherSettingsButtonToggledOn: new UntypedFormControl(false),
            patientIdListWithKeyEpisodesCapableDevice: new UntypedFormControl(null),
            rfDailyCheckEnabled: new UntypedFormControl(false),
            scheduleButtonToggledOnnew: new UntypedFormControl(false),
            showIdentifyKeyEpisodesSetting: new UntypedFormControl(false),
            transmitterButtonToggledOn: new UntypedFormControl(false),
            patTxSettings: this.getPatTxSettingsForm()
        });
    }

    ngOnInit() {
        this.translateStrings();
        this.noScheduledTransmissionHtml = this.translate('msg.gb.manual_sched_prompt', null, 'html');
        this.spinnerService.visibility = true;
        this.getUserData();
        this.getPatientDeviceData();
        this.getData();
        this.getErrorMessageData();
        this.getPatRes();
        this.patTxSettingsForm = this.followupScheduleForm.get('patTxSettings') as UntypedFormGroup;
        this.enrollService.updateDeviceFormDirty(false);
        if (this.functionMode === 'profile') {
            this.followupScheduleForm.disable({ emitEvent: false });
        }
        this.followupScheduleForm.valueChanges.pipe(distinctUntilChanged(), debounceTime(500)).subscribe((res) => {
            if (!this.isActiveStep) {
                return;
            }
            if (this.followupScheduleForm.touched && (this.editMode() || this.functionMode == 'enroll')) {
                this.enrollService.updateDeviceFormDirty(
                    this.followupScheduleForm.dirty
                );
            }
            });
        this.updateCheckboxState();
        // this.followupScheduleForm
        //     .get('schedulingMethodCd').valueChanges.subscribe(r => {
        //         setTimeout(() => //this.resetErrors(),
        //         50)
        //     })
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    appendStringsToLabelList(listToAppend: string[]){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, listToAppend);
    }

    resetErrors() {
        const smartScheduleForm = this.followupScheduleForm.get('smartSchedule') as UntypedFormGroup;
        const permSchedule = smartScheduleForm.get('permSchedule') as UntypedFormGroup;
        permSchedule.get('startDate')?.setErrors(null);

        let tempScheduleForm = smartScheduleForm.get('tempSchedule') as UntypedFormGroup;
        tempScheduleForm.get('startDate')?.setErrors(null);

        const manualScheduleForm = this.followupScheduleForm.get('discSchedule') as UntypedFormGroup;
        const discDates = manualScheduleForm.get("discreteDates") as UntypedFormArray;
        discDates?.at(0)?.get('date')?.setErrors(null);

        // this.enrollService.isDeviceFormDirty = true;
        // this.followupScheduleForm.markAsDirty();
        this.enrollService.updateDeviceFormDirty(
            false
        );
        this.displayMode = 'view';
        this.followupScheduleForm.disable();
    }
    getValue(flg): any {
        return this.patTxSettingsForm.get(flg).value;
    }

    showOverride() {
        if (this.displayMode != 'view') {
            return (this.getValue('clearEgmsFlg') != this.patientData.customer.clinicTxSettings.clearEgmsFlg)
                || (this.getValue('clearStatsDiagnosticsFlg') != this.patientData.customer.clinicTxSettings.clearStatsDiagnosticsFlg)
                || (this.getValue('clearEpisodalDiagnosticsFlg') != this.patientData.customer.clinicTxSettings.clearEpisodalDiagnosticsFlg)
                || (this.getValue('clearEpisodeEgmDiagFlg') != this.patientData.customer.clinicTxSettings.clearEpisodeEgmDiagFlg)
                || (this.getValue('clearStMonitorFlg') != this.patientData.customer.clinicTxSettings.clearStMonitorFlg)
                || (this.getValue('clearEpisInclEgmFlg') != this.patientData.customer.clinicTxSettings.clearEpisInclEgmFlg)
                || (this.getValue('clearDiagFlg') != this.patientData.customer.clinicTxSettings.clearDiagFlg)
        } else {
            return false;
        }
    }

    showOverrideButton() {
        if (this.functionMode == 'enroll') {
        return this.clearOverrideShow('clearEgmsFlg') ||
            this.clearOverrideShow('clearDiagFlg') ||
            this.clearOverrideShow('clearEpisodalDiagnosticsFlg') ||
            this.clearOverrideShow('clearEpisodeEgmDiagFlg') ||
            this.clearOverrideShow('clearStMonitorFlg') && !this.stDiagInclStEgmEnabled() ||
            this.clearOverrideShow('clearEpisInclEgmFlg') ||
            this.clearOverrideShow('clearStatsDiagnosticsFlg');
        } else if (this.displayMode == 'edit') {
            return this.clearOverrideShow('clearEgmsFlg') ||
            this.clearOverrideShow('clearDiagFlg') ||
            this.clearOverrideShow('clearEpisodalDiagnosticsFlg') ||
            this.clearOverrideShow('clearEpisodeEgmDiagFlg') ||
            this.clearOverrideShow('clearStMonitorFlg') && !this.stDiagInclStEgmEnabled()||
            this.clearOverrideShow('clearEpisInclEgmFlg') ||
            this.clearOverrideShow('clearStatsDiagnosticsFlg');
        }
    }

    getPatTxSettingsForm(): UntypedFormGroup {
        return this.fb.group({
            clearDiagFlg: new UntypedFormControl(false),
            clearEgmsFlg: new UntypedFormControl(false),
            clearEpisInclEgmFlg: new UntypedFormControl(false),
            clearEpisodalDiagnosticsFlg: new UntypedFormControl(false),
            clearEpisodeEgmDiagFlg: new UntypedFormControl(false),
            clearStMonitorFlg: new UntypedFormControl(false),
            clearStatsDiagnosticsFlg: new UntypedFormControl(false),
            deviceCheckFlg: new UntypedFormControl(false),
            deviceSwitchOverrideFlg: new UntypedFormControl(false),
            enableMedFlg: new UntypedFormControl(false),
            transmitterVolumeCd: new UntypedFormControl(null)
        })
    }

    disableSmartScheduleForm() {
        if (this.viewMode() && this.functionMode == 'profile') {
            let smartScheduleForm = this.followupScheduleForm.get(
                'smartSchedule'
            ) as UntypedFormGroup;
            smartScheduleForm.get('tempEnabledFlg').disable();
            (smartScheduleForm.get('permSchedule') as UntypedFormGroup).disable();
            (smartScheduleForm.get('tempSchedule') as UntypedFormGroup).disable();
        }
    }

    createManualScheduleForm() {
        let discreteGroup: UntypedFormGroup = this.fb.group({
            disSchdChangedFlg: [false],
            discreteDates: this.fb.array([]),
        });
        return discreteGroup;
    }
    createSmartScheduleForm() {
        return this.fb.group({
            permSchedule: this.fb.group({
                calculateFlg: new UntypedFormControl(false),
                durationCd: new UntypedFormControl(''),
                frequencyCd: new UntypedFormControl(''),
                schdChangedFlg: new UntypedFormControl(''),
                startDate: new UntypedFormControl(''),
                transmitOnDayCd: new UntypedFormControl(''),
                transmitOnMonthCd: new UntypedFormControl(''),
                transmitOnWeekCd: new UntypedFormControl(''),
            }),
            tempEnabledFlg: new UntypedFormControl(false),
            tempSchedule: this.fb.group({
                calculateFlg: new UntypedFormControl(false),
                durationCd: new UntypedFormControl(''),
                frequencyCd: new UntypedFormControl(''),
                schdChangedFlg: new UntypedFormControl(''),
                startDate: new UntypedFormControl(''),
                transmitOnDayCd: new UntypedFormControl(''),
                transmitOnMonthCd: new UntypedFormControl(''),
                transmitOnWeekCd: new UntypedFormControl(''),
            }),
        });
    }

    translateOption(key: string, code: string) {
        return this.localizationService.generateLocalizedStr(key + '.' + code);
    }

    makeDirty(e, scheduleMode = false) {
        if (scheduleMode === true) {
            this.showReminderMsg = true;
        } else {
            this.showReminderMsg = false;
        }
        this.enrollService.updateDeviceFormDirty(true);
    }

    ngAfterViewInit() { }
    translate(key: string, param?: any, type?: string) {
        return this.localizationService.generateLocalizedStr(
            key,
            param ? param : null,
            type ? type : 'text'
        );
    }
    getErrorMessageData() {
        this.messages = this.messageDataService.getData();
    }

    getTransmissionDate(date) {
        return this.helperService.parseDateTime(date, true, true);
    }
    newDiscreteDate(date): UntypedFormGroup {
        let value;
        const format = this.datePlaceholder.toLocaleUpperCase();
        if (date != '' && date != null) {
            value = moment(date, format);
        } else {
            value = '';
        }
        return this.fb.group({
            date: new UntypedFormControl({
                disabled:
                    this.displayMode == 'view' &&
                    this.functionMode == 'profile',
                value: value,
            }),
        });
    }

    makeEnableDateControl = (formArray: UntypedFormArray, mode: string) => {
        let i = 0;
        while (i < formArray.length) {

            if (mode == 'view' && this.functionMode == 'profile') {
                formArray.at(i).get('date').disable();
            } else {
                formArray.at(i).get('date').enable();
            }
            i++;
        }
    };
    getCorrectDate(date: string) {
        const dateFormat = this.datePlaceholder.toUpperCase();
        if (date != '') {
            switch (dateFormat) {
                case 'DD-MM-YYYY':
                    const [day, month, year] = date.split('-');
                    return [year, month, day].join('-');
                case 'MM-DD-YYYY':
                    const [month1, day1, year1] = date.split('-');
                    return [year1, month1, day1].join('-');
                case 'YYYY-MM-DD':
                    const [year2, month2, day2] = date.split('-');
                    return [year2, month2, day2].join('-');
            }
        }
        return '';
    }


    customSort(a, b) {
        const order = { 'd': 0, 'W': 1, 'M': 2 };
        a = {
            ...a,
            code: a.code == '0M' ? '99M' : a.code
        }
        b = {
            ...b,
            code: b.code == '0M' ? '99M' : b.code
        }
        const numA = parseInt(a.code);
        const numB = parseInt(b.code);

        if (!isNaN(numA) && !isNaN(numB)) {
            const unitA = a.code.match(/[a-zA-Z]+/)[0];
            const unitB = b.code.match(/[a-zA-Z]+/)[0];

            if (unitA === unitB) {
                return numA - numB;
            } else {
                return order[unitA] - order[unitB];
            }
        }

        return a.code.localeCompare(b.code);
    }




    getData() {

        this.dataLoaded = false;
        const isAdd = this.functionMode == 'profile' ? false : true;
        // this.followupScheduleForm.get('discSchedule').this.createManualScheduleForm()
        // const control = <FormArray>this.followupScheduleForm.controls['discSchedule'].get('discreteDates').controls;
        // for(let i = control.length-1; i >= 0; i--) {
        //   control.removeAt(i)
        // }
        this.clearFormArray(
            (
                this.followupScheduleForm.get(
                    'discSchedule'
                ) as UntypedFormGroup
            ).get('discreteDates') as UntypedFormArray
        );
        this.followupService
            .getFollowupScheduleData(this.patiendIdToSearch, isAdd)
            .subscribe(
                (response) => {
                    if (response) {
                        this.deviceInductive = response?.patient?.patDevice?.deviceInductive;
                        this.followupCapableFlg = response.patient?.patDevice?.followupCapableFlg;
                        this.stCapableFlg = response.patient?.patDevice?.stCapableFlg;
                        this.datePlaceholder =
                            response?.customer?.dateFormat?.toUpperCase();
                        const dayCodeDisplayPriority = [
                            "SUN",
                            "MON",
                            "TUE",
                            "WED",
                            "THU",
                            "FRI",
                            "SAT"
                        ]
                        response = {
                            ...response,
                            smartSchedule: {
                                ...response.smartSchedule,
                                permSchedule: {
                                    ...response.smartSchedule.permSchedule,
                                    transmitOnMonthCd: [null, 0, ''].includes(response.smartSchedule.permSchedule.transmitOnMonthCd) ?
                                        null : response.smartSchedule.permSchedule.transmitOnMonthCd
                                }
                            },
                            codes: {
                                ...response.codes,
                                permSchdDurationCodes: response?.codes?.permSchdDurationCodes?.sort(this.customSort),
                                permSchdFrequencyCodes: response?.codes?.permSchdFrequencyCodes?.sort(this.customSort),
                                tempSchdDurationCodes: response?.codes?.tempSchdDurationCodes?.sort((a, b) => a.codeId - b.codeId),
                                tempSchdFrequencyCodes: response?.codes?.tempSchdFrequencyCodes?.sort((a, b) => a.codeId - b.codeId),
                                transmitDayCodes: this.helperService.sortCodeObjectsByCode(dayCodeDisplayPriority, response?.codes?.transmitDayCodes),
                                transmitMonthCodes: response?.codes?.transmitMonthCodes.sort((a, b) => a.codeId - b.codeId),
                                transmitWeekCodes: response?.codes?.transmitWeekCodes.sort((a, b) => a.codeId - b.codeId),

                            }
                        }
                        this.patientData = response;
                        this.originalData = JSON.parse(JSON.stringify(response));
                        this.dataLoaded = true;

                        this.schdMethodCodes = response.codes.schdMethodCodes.sort((a, b) => a.codeId - b.codeId);
                        this.parseScdhMethodCodesLabels(this.schdMethodCodes);
                        response.schedulingMethodCd = [null, ''].includes(response.schedulingMethodCd) ? 511 : response.schedulingMethodCd;
                        this.followupScheduleForm
                            .get('schedulingMethodCd')
                            .setValue(response.schedulingMethodCd);
                        this.lastTransMissionDate = this.getDateTime(response?.patient?.lastTransmissionDtm);

                        if (this.patientData.schedulingMethodCd) {
                            this.scheduleMode =
                                this.patientData.schedulingMethodCd.toString();
                        }
                        this.permScheduleCalc = this.boolToString(
                            response.smartSchedule.permSchedule.calculateFlg
                        );
                        this.patientData.discSchedule.discreteDates =
                            this.patientData.discSchedule.discreteDates
                                .sort((a, b) => moment(a, this.datePlaceholder.toLocaleUpperCase()).diff(moment(b, this.datePlaceholder.toLocaleUpperCase()), 'days'))
                                .map((item) => {
                                    (
                                        (
                                            this.followupScheduleForm.get(
                                                'discSchedule'
                                            ) as UntypedFormGroup
                                        ).get('discreteDates') as UntypedFormArray
                                    ).push(this.newDiscreteDate(item));
                                    return item;
                                });

                        this.orginalManualDates = JSON.parse(JSON.stringify(this.patientData.discSchedule.discreteDates));

                        this.followupScheduleForm
                            .get('schedulingMethodCd')
                            .setValue(response.schedulingMethodCd);

                        this.followupScheduleForm
                            .get('smartSchedule')
                            .patchValue(response.smartSchedule);
                        this.followupScheduleForm
                            .get('patTxSettings')
                            .patchValue(response.patTxSettings);
                        let startDate: any =
                            response.smartSchedule.permSchedule.startDate != null &&
                                response.smartSchedule.permSchedule.startDate != ''
                                ? moment(response.smartSchedule.permSchedule.startDate, this.datePlaceholder.toLocaleUpperCase())
                                : '';
                        let tempStartDate: any =
                            response.smartSchedule.tempSchedule.startDate != null &&
                                response.smartSchedule.tempSchedule.startDate != ''
                                ? moment(response.smartSchedule.tempSchedule.startDate, this.datePlaceholder.toLocaleUpperCase())
                                : '';

                        // if (startDate != '') {
                        //     // startDate.setMinutes(
                        //     //     startDate.getMinutes() +
                        //     //     startDate.getTimezoneOffset()
                        //     // );
                        //     startDate = this.helperService.parseGMTDateTime(startDate, false,
                        //         true,
                        //         this.userProfData.clinicUserTZ,
                        //         'YYYY-MM-DD'
                        //     );
                        // }
                        //  if (tempStartDate != '') {
                        //     tempStartDate = this.helperService.parseGMTDateTime(tempStartDate, false,
                        //         true,
                        //         this.userProfData.clinicUserTZ,
                        //         'YYYY-MM-DD'
                        //     );
                        // }

                        (
                            (
                                this.followupScheduleForm.get(
                                    'smartSchedule'
                                ) as UntypedFormGroup
                            ).get('permSchedule') as UntypedFormGroup
                        )
                            .get('startDate')
                            .setValue(startDate);
                        (
                            (
                                this.followupScheduleForm.get(
                                    'smartSchedule'
                                ) as UntypedFormGroup
                            ).get('tempSchedule') as UntypedFormGroup
                        )
                            .get('startDate')
                            .setValue(tempStartDate);

                        let permScheduleForm = (
                            this.followupScheduleForm.get(
                                'smartSchedule'
                            ) as UntypedFormGroup
                        ).get('permSchedule') as UntypedFormGroup;
                        if (
                            response.smartSchedule.permSchedule.calculateFlg.toString() == 'false'
                        ) {
                            permScheduleForm.get('startDate').disable();
                            permScheduleForm.get('transmitOnWeekCd').enable();
                            permScheduleForm.get('transmitOnDayCd').enable();
                            permScheduleForm.get('transmitOnMonthCd').enable();

                            permScheduleForm.get('startDate').clearValidators();
                            permScheduleForm
                                .get('transmitOnWeekCd')
                                .setValidators([Validators.required]);
                            permScheduleForm
                                .get('transmitOnDayCd')
                                .setValidators([Validators.required]);
                            permScheduleForm
                                .get('transmitOnMonthCd')
                                .setValidators([Validators.required]);
                            permScheduleForm
                                .get('startDate')
                                .updateValueAndValidity();

                            permScheduleForm
                                .get('transmitOnWeekCd')
                                .updateValueAndValidity();
                            permScheduleForm
                                .get('transmitOnDayCd')
                                .updateValueAndValidity();
                            permScheduleForm
                                .get('transmitOnMonthCd')
                                .updateValueAndValidity();
                        } else {
                            permScheduleForm.get('startDate').enable();
                            permScheduleForm.get('transmitOnWeekCd').disable();
                            permScheduleForm.get('transmitOnDayCd').disable();
                            permScheduleForm.get('transmitOnMonthCd').disable();

                            permScheduleForm
                                .get('startDate')
                                .setValidators([Validators.required]);
                            permScheduleForm
                                .get('transmitOnWeekCd')
                                .clearValidators();
                            permScheduleForm
                                .get('transmitOnDayCd')
                                .clearValidators();
                            permScheduleForm
                                .get('transmitOnMonthCd')
                                .clearValidators();
                            permScheduleForm
                                .get('startDate')
                                .updateValueAndValidity();
                            permScheduleForm
                                .get('transmitOnWeekCd')
                                .updateValueAndValidity();
                            permScheduleForm
                                .get('transmitOnDayCd')
                                .updateValueAndValidity();
                            permScheduleForm
                                .get('transmitOnMonthCd')
                                .updateValueAndValidity();
                        }
                        if (!response.smartSchedule.tempEnabledFlg) {
                            (
                                (
                                    this.followupScheduleForm.get(
                                        'smartSchedule'
                                    ) as UntypedFormGroup
                                ).get('tempSchedule') as UntypedFormGroup
                            ).disable();
                        } else {
                            if (response.smartSchedule.tempSchedule.calculateFlg.toString() == 'true') {
                                let tmpScheduleForm = (
                                    this.followupScheduleForm.get(
                                        'smartSchedule'
                                    ) as UntypedFormGroup
                                ).get('tempSchedule') as UntypedFormGroup;
                                tmpScheduleForm.get('transmitOnDayCd').disable();
                                tmpScheduleForm.get('transmitOnMonthCd').disable();
                                tmpScheduleForm.get('transmitOnWeekCd').disable();

                                tmpScheduleForm
                                    .get('startDate')
                                    .setValidators([Validators.required]);
                                tmpScheduleForm
                                    .get('startDate')
                                    .updateValueAndValidity();
                            } else {
                                let tmpScheduleForm = (
                                    this.followupScheduleForm.get(
                                        'smartSchedule'
                                    ) as UntypedFormGroup
                                ).get('tempSchedule') as UntypedFormGroup;
                                tmpScheduleForm.get('startDate').disable();

                                tmpScheduleForm.get('startDate').clearValidators();
                                tmpScheduleForm
                                    .get('startDate')
                                    .updateValueAndValidity();
                                tmpScheduleForm
                                    .get('transmitOnDayCd')
                                    .setValidators([Validators.required]);
                                tmpScheduleForm
                                    .get('transmitOnMonthCd')
                                    .setValidators([Validators.required]);
                                tmpScheduleForm
                                    .get('transmitOnWeekCd')
                                    .setValidators([Validators.required]);
                                tmpScheduleForm
                                    .get('transmitOnDayCd')
                                    .updateValueAndValidity();
                                tmpScheduleForm
                                    .get('transmitOnMonthCd')
                                    .updateValueAndValidity();
                                tmpScheduleForm
                                    .get('transmitOnWeekCd')
                                    .updateValueAndValidity();
                            }
                        }
                        if (response.patient.patDevice.deviceType == 'ICM') {
                            permScheduleForm.get('durationCd').setValue(1169);
                            permScheduleForm.get('durationCd').disable();
                        }
                        this.disableSmartScheduleForm();
                        this.errorData = {};
                        this.highlightErrorFields();
                    }
                    this.setInitialValidator();
                  //  this.followupScheduleForm.markAsPristine();
                },
                (error) => {
                    this.toastService.error(error?.message, null, {
                        disableTimeOut: true,
                        enableHtml: false,
                        tapToDismiss: false
                    })
                }
            );
    }

    parseScdhMethodCodesLabels(methodCodes){
        let stringsToAppend = [];

        for(let method of methodCodes){
            stringsToAppend.push(
                'data.Code.Scheduling_Method_Cd.Code_Desc.' + method.code
            )
        }

        this.appendStringsToLabelList(stringsToAppend);
    }

     getDateTime(date: Date) {
        let tempDate =this.helperService.parseGMTDateTime(
            date,
            true,
            false,
            this.userProfData?.clinicUserTZ,
            this.userProfData?.dateFormat,
            null
        );
        if(tempDate != 'msg.pa600.text'){
            return tempDate.split(',')[0];
        }
        return '';
    }
    locale: string = 'en-US';
    tz: string = 'Etc/UTC';
    getUserData() {
        this.userService
            .getUserProfile(false)
            .subscribe((userData: UserProfileObject) => {
                this.dateFormatService.format = userData.dateFormat;
                this.datePlaceholder = userData.dateFormat.toUpperCase();
                this.userProfData = userData;
                this.tz = userData.clinicUserTZ;
                this.activatorClinicFlg = this.userProfData.activatorClinicFlg;
                this.legalJurisdiction = userData.legalJurisdiction;
                this.hasPatientDataEntryAccess = userData?.canEnroll;
                this.helperService.setAppLocale(userData.locale);
                localStorage.setItem('dateFormat', userData.dateFormat);
                this.locale = userData.locale;
                this.isSP2CanEnroll =
                    userData.customerType === 'CL'
                        ? true
                        : userData?.customerType === 'SP2' &&
                        userData?.canEnroll;
            });
    }

    getPatientDeviceData() {
        this.requestService.getPatientProfile().subscribe((data) => {
            if (data?.messaging) {
                if (data?.messaging?.msgReminderFlg === false) {
                    this.showReminderMsg = false;
                }
            }
        });
    }

    adaptDate(date: string) {
        // let dateFormatObj = this.userProfData.dateFormat;
        // let dateFormatSplit = dateFormatObj.split('-');
        // if (date == '' || date == null) {
        //     return '';
        // } else {
        //     let dateKeyObj = {};
        //     let tempdateData = date.split('-');
        //     for (let i = 0; i < dateFormatSplit.length; i++) {
        //         dateKeyObj[dateFormatSplit[i]] = tempdateData[i];
        //     }
        //     let newDate = new Date(
        //         +dateKeyObj['yyyy'],
        //         +dateKeyObj['MM'] - 1,
        //         +dateKeyObj['dd']
        //     );
        //     return newDate;
        // }
        return date;
    }

    calculateInterval(index1: number, index2: number) {
        let dateList = this.patientData.discSchedule.discreteDates;
        if (dateList[index1] == '' || dateList[index2] == '') {
            return '---';
        } else {
            const days =
                (dateList[index2] - dateList[index1]) / (1000 * 3600 * 24);
            if (days >= 0) {
                return (
                    (dateList[index2] - dateList[index1]) / (1000 * 3600 * 24) +
                    ' days'
                );
            } else {
                return '---';
            }
        }
    }

    boolToString(val: boolean) {
        if (val == true) {
            return 'true';
        } else {
            return 'false';
        }
    }

    permPickerActive() {
        if (this.viewModeDisable()) {
            return true;
        }
        if (this.permScheduleCalc == 'true') {
            return false;
        } else {
            return true;
        }
    }

    permDropDownActive() {
        if (this.viewModeDisable()) {
            return true;
        }
        if (this.permScheduleCalc == 'false') {
            return false;
        } else {
            return true;
        }
    }

    tempGroupActive() {
        if (this.viewModeDisable()) {
            return true;
        }
        if (this.patientData.smartSchedule.tempEnabledFlg) {
            return false;
        } else {
            return true;
        }
    }

    tempPickerActive() {
        if (this.viewModeDisable()) {
            return true;
        }
        if (this.patientData.smartSchedule.tempEnabledFlg == false) {
            return true;
        }
        if (this.tempScheduleCalc == 'true') {
            return false;
        } else {
            return true;
        }
    }

    tempDropDownActive() {
        if (this.viewModeDisable()) {
            return true;
        }
        if (this.patientData.smartSchedule.tempEnabledFlg == false) {
            return true;
        }
        if (this.tempScheduleCalc == 'false') {
            return false;
        } else {
            return true;
        }
    }

    tempFreqDurActive() {
        if (this.viewModeDisable()) {
            return true;
        }
        if (this.patientData.smartSchedule.tempEnabledFlg == false) {
            return true;
        } else {
            return false;
        }
    }
    getConfirmDialogBox(message) {
        return {
            type: PopupType.Confirm,
            message:
                this.localizationService.generateLocalizedStr(
                    message, '', 'html'
                ),
            confirmText:
                this.localizationService.generateLocalizedStr(
                    'label.gb.ok'
                ),
            confirmId: this.identifierService.buttonId(
                'pending-transfer-popup',
                'ok'
            ),
            cancelId: this.identifierService.buttonId(
                'pending-transfer-popup',
                'cancel001'
            ),
            cancelText: this.localizationService.generateLocalizedStr(
                'label.gb.button_cancel'
            ),
            customPopup: true,
        };
    }


    onSaveButtonClick(navAway: boolean) {
        this.toastRef?.toastId ? this.toastService.clear(this.toastRef.toastId) : '';
        let isSaved: boolean = false;
        this.followupScheduleForm.markAsDirty();
        if (this.followupScheduleForm.dirty || this.functionMode == 'enroll') {
            if (
                !this.stDiagInclStEgmEnabled()
                && (this.patTxSettingsForm.get("clearStMonitorFlg").value
                    && this.patTxSettingsForm.get("clearStMonitorFlg").dirty)
            ) {
                isSaved = true;
                const dialogConfig: PopupConfig = this.getConfirmDialogBox('msg.pa867.text')
                this.popupService.open(dialogConfig);
                this.popupService.confirmed().subscribe((res) => {
                    if (res === true) {
                        this.saveData(navAway);
                    } else {
                        return;
                    }
                });
            }
            else {
                if (!isSaved) { this.saveData(navAway); }
            }
        } else {
            this.setDisplayMode('view');
            this.displayMode = 'view';
            this.followupScheduleForm.markAsPristine();
            this.disableSmartScheduleForm();
            this.enrollService.updateDeviceFormDirty(false);
        }
    }

    onSaveAndCloseWithXssValidation(): void {
        const scope = this.elementRef.nativeElement;
        if (!this.globalInputSecurity.validateScopeForXss(scope)) {
            return;
        }
        this.onSaveButtonClick(true);
    }

    isExistingDataChange(date, index): boolean {
        const backupData = this.orginalManualDates[index];
        if (date != '') {
            const formattedDate = moment(date).tz(this.userProfData?.clinicUserTZ).format(this.datePlaceholder?.toUpperCase());

            return formattedDate != backupData;
        } else {
            return false;
        }
    }

    validateManuschedule() {
        const discScheduleForm = this.followupScheduleForm.get(
            'discSchedule'
        ) as UntypedFormGroup;
        let discDates = discScheduleForm.get("discreteDates") as UntypedFormArray;
        const manualFormRawData = this.followupScheduleForm.getRawValue();
        const prevScheduleDate =
            manualFormRawData.discSchedule.discreteDates.filter((item: any, index) => {
                const isOverrideExistingDate = this.isExistingDataChange(item.date, index);
                if (isOverrideExistingDate && item.date) {
                    const date = item.date.toISOString().split('T')[0];
                    return !['', null].includes(item.date) && this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ) > new Date(date + 'T00:00:00');
                }
                return false;
            });
        const sortedDates = manualFormRawData.discSchedule.discreteDates
            .filter((item: any) => {
                return ![null, ""].includes(item.date);  // != '';
            })
            .sort((a, b) => {
                return new Date(a.date).getTime() - new Date(b.date).getTime();
            });
        if (prevScheduleDate.length > 0) {

            discDates.controls.forEach((element) => {
                if (element.get('date').value && (this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ) >= new Date(element.get('date').value))) {
                    element.get('date').setErrors({ invalid: true })
                }
            });

            const errorMsg = this.localizationService.generateLocalizedStr(
                'msg.pa860.text',
                { '0': 12 },
                'html'
            );
            this.toastRef = this.toastService.error(errorMsg, null, {
                enableHtml: true,
                disableTimeOut: true,
            });
            return false;
        }

        let inputValue = [];
        let initialDateNull = false;
        for (let i = 0; i < discScheduleForm.get('discreteDates')['controls'].length; i++) {
            let inputEle = (document.getElementById('manual_date_' + i) as HTMLInputElement)?.value;

            if (inputEle === '' && i === 0) {
                initialDateNull = true;
            } else if (inputEle !== '' && typeof inputEle != 'undefined') {
                if(!this.helperService.dateValidator(inputEle, this.userProfData?.dateFormat)) {
                    inputValue.push(inputEle);
                }
            }
        }

        if (initialDateNull) { //BOOKMARK
            const reqerrorMsg = this.localizationService.generateLocalizedStr(
                'msg.pa857b.text',
                null,
                'html'
            );
            this.toastRef = this.toastService.show(reqerrorMsg, null, {
                enableHtml: true,
                disableTimeOut: false,
                tapToDismiss: false,
                closeButton: true,
                toastClass: `${ToasterClass.userNotificationMessageA} ${ToasterClass.ngxToastr}`,
            });
            discDates.at(0).get('date').markAsTouched();
            discDates.at(0).get('date').setErrors({ required: true })
            return;
        }

        if (sortedDates.length == 0 || inputValue.length > 0) {


            let errorArray = [];
            let errorMsg = this.localizationService.generateLocalizedStr(
                'msg.cs816.text',
                { 0: '' },
                'html'
            );
            errorArray.push(errorMsg);
            errorArray.push(this.localizationService.generateLocalizedStr(
                'label.gb.transmit_on',
                null,
                'html'
            ));
            let getLabel = this.getDateLabel();
            errorArray.push(this.localizationService.generateLocalizedStr(
                'msg.cs816.text_appendix',
                { 0: getLabel },
                'html'
            ));

            const errorArrayMsg = this.helperService.getErrorList(errorArray);

            this.toastService.error(errorArrayMsg, null, {
                enableHtml: true,
                disableTimeOut: true,
            });
            return false;
        }

        if (sortedDates.length > 1) {
            const dateGaps = sortedDates.map((currentItem, index, arr) => {
                return index + 1 < arr.length
                    ? Math.round(
                        Math.abs(
                            Number(arr[index + 1].date) -
                            Number(currentItem.date)
                        ) /
                        (24 * 60 * 60 * 1000)
                    )
                    : 0;
            });
            dateGaps.pop();
            const isGapLessThan3 = dateGaps.some((el) => el < 3);
            if (isGapLessThan3) {
                discDates.controls.forEach((element) => {
                    if (element?.get('date')?.value) {
                        element?.get('date')?.setErrors({ invalid: true })
                        element?.get('date')?.markAsTouched();
                    }
                });

                const errorMsg = this.localizationService.generateLocalizedStr(
                    'msg.pa865.text',
                    { '0': 3 },
                    'html'
                );
                this.toastRef = this.toastService.error(errorMsg, null, {
                    enableHtml: true,
                    disableTimeOut: true,
                });
                return false;
            }
        }
        return true;
    }

    getDateLabel() {
        let key = this.userProfData?.dateFormat?.toUpperCase() == 'DD-MM-YYYY'
            ? 'label.gb.ddmmyyyy' :
            this.userProfData?.dateFormat?.toUpperCase() == 'MM-DD-YYYY'
                ? 'label.gb.mmddyyyy' : 'label.gb.yyyymmdd';
        return this.localizationService.generateLocalizedStr(key);
    }
    isValidDate(d: any) {
        return d instanceof Date && !isNaN(d as any);
    }

    getValidTimeZoneDate(inputDate): string {
        if (inputDate == null || inputDate == '') {
            return this.userProfData.dateFormat.toUpperCase();
        } else {
            if (inputDate == 'MM-DD-YYYY') {
                return 'MM-DD-YYYY';
            }
            const mdate = new Date(inputDate);
            var [year, month, day] = mdate
                .toISOString()
                .split('T')[0]
                .split('-');
            if (this.datePlaceholder.toUpperCase() == 'YYYY-MM-DD') {
                return [year, month, day].join('-');
            } else if (this.datePlaceholder.toUpperCase() == 'MM-DD-YYYY') {
                return [month, day, year].join('-');
            } else {
                return [day, month, year].join('-');
            }
            // mdate.setMinutes(mdate.getMinutes() + mdate.getTimezoneOffset());
            // return moment
            //     .tz(mdate, this.userProfData.clinicUserTZ)
            //     .utc()
            //     .format(this.userProfData.dateFormat.toUpperCase());
        }
        // return inputDate;
    }
    clearFormArray = (formArray: UntypedFormArray) => {
        while (formArray.length !== 0) {
            formArray.removeAt(0);
        }
    };

    getAlertDialogRef(message: string) {
        const dialogConfig: PopupConfig = {
            type: PopupType.Prompt,
            message: message,
            confirmText:
                this.localizationService.generateLocalizedStr(
                    'label.gb.ok'
                ),
            confirmId: this.identifierService.buttonId(
                'pcs-location-popup',
                'Ok'
            ),
            // cancelId: this.identifierService.buttonId(
            //     'pcs-location-popup',
            //     'cancel001'
            // ),
            // cancelText: '',
            customPopup: true,
        };
        return dialogConfig;
    }

    updateData(navAway: boolean) {
        let isValid = true;
        let payload = this.dataToSend;
        if (
            this.followupScheduleForm.get('schedulingMethodCd').value == 510 &&
            this.followupScheduleForm.dirty
        ) {
            isValid = this.validateManuschedule();
        }

        if (isValid) {
            const rawValue = this.followupScheduleForm.getRawValue();
            payload = {
                ...payload,
                ...this.followupScheduleForm.getRawValue(),
                inputChangedFlg: this.followupScheduleForm.dirty,
                smartSchedule: {
                    ...this.followupScheduleForm.getRawValue().smartSchedule,
                    permSchedule: {
                        ...this.followupScheduleForm.getRawValue().smartSchedule
                            .permSchedule,
                        startDate: this.getValidTimeZoneDate(
                            this.followupScheduleForm.getRawValue()
                                .smartSchedule.permSchedule.startDate
                        ),
                    },
                    tempSchedule: {
                        ...this.followupScheduleForm.getRawValue().smartSchedule
                            .tempSchedule,
                        startDate: this.getValidTimeZoneDate(
                            this.followupScheduleForm.getRawValue()
                                .smartSchedule.tempSchedule.startDate
                        ),
                    },
                },
                discSchedule: {
                    ...rawValue.discSchedule,
                    discreteDates: rawValue.discSchedule.discreteDates.map(
                        (item: any) => {
                            return this.getValidTimeZoneDate(item.date);
                        }
                    ),
                }
            };
            //  if (this.isManualInductiveNeedtoShow) {
            if (this.deviceInductive && !this.directCallFlg) {
                if (this.followupScheduleForm.get('schedulingMethodCd').value == 510 && !this.diffGreaterThanYear) {
                    const alertMsg = this.localizationService.generateLocalizedStr('msg.pa864.text');
                    const dialogConfig = this.getAlertDialogRef(alertMsg);
                    this.popupService.open(dialogConfig);
                    this.popupService.dialogRef
                        .afterClosed()
                        .subscribe((response: any) => {
                            if (response) {
                                this.updateFollowup(navAway, payload);
                            }
                        });
                } else {
                    this.updateFollowup(navAway, payload);
                }
            } else {
                if (this.followupScheduleForm.get('schedulingMethodCd').value == 510) {
                    if (this.isLessThan7daysManual() && (this.originalData?.patient?.patDevice?.deviceType != "NGQ")
                        && (this.originalData?.patient?.patDevice?.deviceType != "ICM")) {
                        const dialogConfig = this.getDialogRef('msg.pa857a.text');
                        this.popupService.open(dialogConfig);
                        this.popupService.dialogRef
                            .afterClosed()
                            .subscribe((response: any) => {
                                if (response) {
                                    this.updateFollowup(navAway, payload)
                                }
                            });
                    } else {
                        this.updateFollowup(navAway, payload)
                    }
                } else {
                    this.updateFollowup(navAway, payload)
                }
            }
            // } else {
            //     this.updateFollowup(navAway, payload)
            // }
        }
    }

    getValueIfNotDisabled(selected: boolean, value) {
        return selected ? value : null;
    }

    updateFollowup(navAway, payload) {
        let updatePayload = {
            ...payload,
            smartSchedule: {
                ...payload.smartSchedule,
                tempSchedule: {
                    ...payload.smartSchedule.tempSchedule,
                    startDate: this.getValueIfNotDisabled(payload.smartSchedule.tempEnabledFlg, payload.smartSchedule.tempSchedule.startDate),
                    calculateFlg: payload.smartSchedule.tempEnabledFlg ? payload.smartSchedule.tempSchedule.calculateFlg : null,
                    durationCd: this.getValueIfNotDisabled(payload.smartSchedule.tempEnabledFlg, payload.smartSchedule.tempSchedule.durationCd),
                    frequencyCd: this.getValueIfNotDisabled(payload.smartSchedule.tempEnabledFlg, payload.smartSchedule.tempSchedule.frequencyCd),
                    transmitOnDayCd: this.getValueIfNotDisabled(payload.smartSchedule.tempEnabledFlg, payload.smartSchedule.tempSchedule.transmitOnDayCd),
                    transmitOnMonthCd: this.getValueIfNotDisabled(payload.smartSchedule.tempEnabledFlg, payload.smartSchedule.tempSchedule.transmitOnMonthCd),
                    transmitOnWeekCd: this.getValueIfNotDisabled(payload.smartSchedule.tempEnabledFlg, payload.smartSchedule.tempSchedule.transmitOnWeekCd),
                }
            }

        }
        let isTemp = payload.smartSchedule.tempEnabledFlg;

        this.followupService
            .updateFollowUpScheduleData(updatePayload, this.patiendIdToSearch)
            .subscribe(
                (response: any) => {
                    this.displayError = false;
                    this.displayMode = 'view';
                    this.isManualInductiveNeedtoShow = false;
                    this.errorData = {};
                    this.highlightErrorFields();
                    // let successMsg = this.localizationService.generateLocalizedStr('msg.cs830.text')
                    //      this.toastService.success(successMsg);  // Display toaster as per CommUI11399
                    // let i =
                    //     this.followupScheduleForm.getRawValue().discSchedule
                    //         .discreteDates.length;

                    // this.clearFormArray(
                    //     (
                    //         this.followupScheduleForm.get(
                    //             'discSchedule'
                    //         ) as FormGroup
                    //     ).get('discreteDates') as FormArray
                    // );
                    this.followupScheduleForm.markAsPristine();
                    this.enrollService.isDeviceFormDirty = false;
                    if (this.functionMode == FunctionMode.PROFILE) {
                        const smartScheduleForm = this.followupScheduleForm.get('smartSchedule') as UntypedFormGroup;
                        let tempScheduleForm = smartScheduleForm.get('tempSchedule') as UntypedFormGroup;
                        if (!isTemp) {
                            tempScheduleForm.get('startDate').setValue(null);
                            tempScheduleForm.get('calculateFlg').setValue(false);
                            tempScheduleForm.get('durationCd').setValue(null);
                            tempScheduleForm.get('frequencyCd').setValue(null);
                            tempScheduleForm.get('transmitOnDayCd').setValue(null);
                            tempScheduleForm.get('transmitOnMonthCd').setValue(null);
                            tempScheduleForm.get('transmitOnWeekCd').setValue(null);
                        }
                    }

                    if (this.isbackActivated) {
                        this.navBackward.emit('back');
                        this.isbackActivated = false;
                    } else {
                        if (navAway) {
                            // this.router.navigate(['/patient-list']);
                            this.toastService.clear();
                            this.navForward.emit('save-close');
                        } else {
                            if (this.isViewScheduleCall) {
                                this.openViewScheduleDialog()
                            }
                            /**to get clear data */
                            this.getData();
                            /**to get clear data */
                            this.isViewScheduleCall = false;
                            this.enrollService.updateDeviceFormDirty(false);
                            this.toastService.clear();
                            this.navForward.emit('next');
                            //  this.getData();
                            this.setDisplayMode('view');
                            this.displayMode = 'view';
                            this.disableSmartScheduleForm();
                        }
                    }
                    this.enrollService.updateDeviceFormDirty(false);
                },
                (error: any) => {
                    // this.displayError = true;
                    if (error?.fields?.length > 0) {
                        let errorHeading =
                            this.localizationService.generateLocalizedStr(
                                'msg.cs816.text',
                                { '0': '' }
                            );
                        errorHeading = errorHeading + '<br/><br/><ul>';
                        for (let i = 0; i < error.fields.length; i++) {
                            if (LOCALIZATION_LABEL[error.fields[i]]) {
                                errorHeading =
                                    errorHeading +
                                    '<li>-' +
                                    this.translateService.instant(
                                        LOCALIZATION_LABEL[error.fields[i]]
                                    ) +
                                    '</ll>';
                            } else if (error.fields[i] == 'discreteDates') {
                                errorHeading =
                                    errorHeading + 'Transmit on date';
                            }
                        }
                        errorHeading = errorHeading + '</ul>';
                        // this.toastrService.error(errorHeading);
                        this.toastrSer.error(errorHeading, null, {
                            enableHtml: true,
                            disableTimeOut: true,
                        });
                    } else {
                        this.errorData = error;
                        this.errorText = error.msgs[0].msg == 'msg.pa860.text' ?
                        this.translate('msg.pa860.text',error.msgs[0].data, 'html') :
                        this.getErrorText();
                        this.toastRef = this.toastrSer.error(this.errorText, null, {
                            enableHtml: true,
                            disableTimeOut: true,
                        });
                        const smartScheduleForm = this.followupScheduleForm.get(
                            'smartSchedule'
                        ) as UntypedFormGroup;
                        const smartScheduleRawData = smartScheduleForm.getRawValue();

                        if (error.msgs[0].msg == 'msg.pa860.text') {
                            if (smartScheduleRawData.permSchedule.calculateFlg.toString() == 'true'
                                && smartScheduleRawData.permSchedule.schdChangedFlg) {
                                const momentDate = smartScheduleRawData.permSchedule.startDate._isAMomentObject ?
                                    this.helperService.getDateWithoutTime(new Date(smartScheduleRawData.permSchedule.startDate.format('YYYY-MM-DDTHH:mm:ss'))) : null;
                                if (
                                    momentDate &&
                                    (this.helperService.getDateWithoutTime(this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ)) >=
                                        momentDate)
                                    ||
                                    this.isDateMoreThanOneYearAway(smartScheduleRawData.permSchedule.startDate)
                                ) {
                                    smartScheduleForm.get('permSchedule').get('startDate').setErrors({ invalid: true })
                                }
                            }

                            if (smartScheduleRawData.tempEnabledFlg) {
                                if (smartScheduleRawData.tempSchedule.calculateFlg.toString() == 'true') {
                                    const momentDate = smartScheduleRawData.tempSchedule.startDate._isAMomentObject ?
                                        this.helperService.getDateWithoutTime(new Date(smartScheduleRawData.tempSchedule.startDate.format('YYYY-MM-DDTHH:mm:ss'))) : null;
                                    if (
                                        momentDate &&
                                        (this.helperService.getDateWithoutTime(this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ)) >=
                                            momentDate)
                                        ||
                                        this.isDateMoreThanOneYearAway(smartScheduleRawData.tempSchedule.startDate)
                                    ) {
                                        smartScheduleForm.get('tempSchedule').get('startDate').markAsDirty();
                                        smartScheduleForm.get('tempSchedule').get('startDate').setErrors({ invalid: true })
                                    }
                                }
                            }
                        }

                        const discScheduleForm = this.followupScheduleForm.get(
                            'discSchedule'
                        ) as UntypedFormGroup;
                        let discDates = discScheduleForm.get("discreteDates") as UntypedFormArray;

                        if (error.msgs[0].msg == 'msg.pa860.text') {
                            let oneYearFromNow = this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ);
                            let sevenDaysFromNow = this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ);
                            sevenDaysFromNow.setDate(sevenDaysFromNow.getDate() + 7);
                            oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
                            sevenDaysFromNow.setHours(0, 0, 0, 0);
                            oneYearFromNow.setHours(0, 0, 0, 0);

                            discDates.controls.forEach((element) => {
                                let elementDate = new Date(element.get('date').value);
                                elementDate.setHours(0, 0, 0, 0);
                                if (element.get('date').value
                                        && ((elementDate >= oneYearFromNow) || (elementDate <= sevenDaysFromNow))) {
                                            if(elementDate <= new Date()){
                                                element.get('date').setErrors({ invalid: true });
                                                element.get('date').markAsTouched();
                                            }
                                }
                            });
                        }
                        // this.formValidators = this.activeValidators;
                        this.highlightErrorFields();
                    }
                }
            );
    }

    highlightErrorFields() {
        this.formKeys.forEach((key) => {
            this.formValidators[key].markAsUntouched();
        });
        if (this.errorData.fields) {
            this.errorData.fields.forEach((field) => {
                this.formValidators[field].markAsTouched();
            });
        }
    }

    compareObjects(ob1: any, ob2: any) {
        if (JSON.stringify(ob1) == JSON.stringify(ob2)) {
            return true;
        } else {
            return false;
        }
    }

    specialTreatDisplay(): boolean {
        if (
            this.patientData.patient?.patDevice?.deviceType.toLowerCase() ==
            'icdpm'
        ) {
            return true;
        } else {
            return false;
        }
    }

    specialTreatmentEnabled() {
        if (this.viewModeDisable()) {
            return true;
        }
        if (this.patientData.patient?.patDevice?.followupCapableFlg) {
            return true;
        } else {
            return false;
        }
    }
    stDiagInclStEgmEnabled() {
        if (this.viewModeDisable()) {
            return true;
        }
        if ((this.legalJurisdiction === 'USA') || (this.stCapableFlg == false)) {
            return true;
        } else {
            return false;
        }
    }

    statDiagDisplay() {
        if (
            this.patientData?.patient?.patDevice.deviceType == 'BLE ICD' ||
            this.patientData?.patient?.patDevice.deviceType == 'NGQ'
        ) {
            return true;
        } else {
            return false;
        }
    }

    ICDStDiagnosticsDisplay() {
        if (this.patientData?.patient?.patDevice.deviceType == 'ICDPM') {
            return true;
        } else {
            return false;
        }
    }

    ICMDiagEpisEGMDisplay() {
        if (this.patientData.patient?.patDevice.deviceType == 'ICM') {
            return true;
        } else {
            return false;
        }
    }

    permDurationDisable() {
        if (this.displayMode == 'view') {
            return false;
        } else if (this.ICMDiagEpisEGMDisplay()) {
            return true;
        } else {
            return false;
        }
    }

    episAndEGMDisplay() {
        if (
            this.patientData.patient?.patDevice.deviceType == 'BLE ICD' ||
            this.patientData.patient?.patDevice.deviceType == 'NGQ'
        ) {
            return true;
        } else {
            return false;
        }
    }

    STMonitorDisplay() {
        // let supportsFollowUpProcessing = this.patientData.patient.patDevice.followupCapableFlg;
        // let jurisdictionValueSTClearing = this.patientData.customer.disableSTClearFlg
        let systemConfigParam = this.patientData.showClearSTDialog;
        let stCapable = this.patientData.patient?.patDevice.stCapableFlg;

        if (!systemConfigParam && stCapable) {
            return true;
        } else if (systemConfigParam) {
            return true;
        } else {
            return false;
        }
    }

    STMonitorEnabled() {
        let supportsFollowUpProcessing =
            this.patientData.patient?.patDevice.followupCapableFlg;
        let jurisdictionEnableSTClearing =
            !this.patientData.customer.disableSTClearFlg;
        // let systemConfigParam = this.patientData.showClearSTDialog
        let stCapable = this.patientData.patient?.patDevice.stCapableFlg;

        if (
            supportsFollowUpProcessing &&
            jurisdictionEnableSTClearing &&
            stCapable
        ) {
            return true;
        } else if (!supportsFollowUpProcessing) {
            return false;
        } else if (
            supportsFollowUpProcessing &&
            !jurisdictionEnableSTClearing
        ) {
            return false;
        } else if (
            supportsFollowUpProcessing &&
            jurisdictionEnableSTClearing &&
            !stCapable
        ) {
            return false;
        } else {
            return true;
        }
    }

    // System configuration parameter -- showClearSTDiag
    // Device is ST Monitoring Capable or ST Phase 2 Capable -- stCapableFlg
    // Device supports follow-up processing -- followupCapableFlg
    // Jurisdiction value for Enabling ST Clearing -- disableSTClearFlg

    getErrorText() {

        let stringToReturn = '';
        let firstRound: boolean = true;
        this.errorData.msgs.forEach((item) => {
            stringToReturn += this.appendErrorText(item, firstRound);
            if (firstRound) {
                firstRound = false;
            }
            if (item.childs != null) {
                item.childs.forEach((childItem) => {
                    stringToReturn += '<br/>';
                    stringToReturn += this.appendErrorText(childItem, false);
                });
            }
        });
        return stringToReturn;
    }

    appendErrorText(item: any, firstRound: boolean) {
        let tempString = '';
        tempString += this.messages[item.msg];
        if (item.data != null) {
            for (let i = 0; i < item.data.length; i++) {
                let replacementVal = '{' + i + '}';
                let replacing = true;
                while (replacing) {
                    tempString = tempString.replace(
                        replacementVal,
                        item.data[i]
                    );
                    if (!tempString.includes(replacementVal)) {
                        replacing = false;
                    }
                }
            }
        }
        return tempString;
    }

    lastTransmissionText() {
        if (this.patientData.lastFollowupDate == null) {
            return '---';
        } else {
            return this.patientData.lastFollowupDate;
        }
    }

    calculateFirstInterval() {
        let dateList = this.patientData.discSchedule.discreteDates;
        if (
            this.patientData.lastFollowupDate == null ||
            this.patientData.discSchedule.discreteDates[0] == ''
        ) {
            return '---';
        } else {
            return (
                (this.patientData.lastFollowupDate - dateList[0]) /
                (1000 * 3600 * 24) +
                ' days'
            );
        }
    }

    showOverrideText() {
        if (
            JSON.stringify(this.originalData.patTxSettings) !==
            JSON.stringify(this.originalData.customer?.clinicTxSettings)
        ) {
            return true;
        } else {
            return false;
        }
    }

    clearOverrideShow(param: string) {
        if (
            this.patTxSettingsForm.get(param).value ==
            this.patientData.customer.clinicTxSettings[param]
        ) {
            return false;
        } else if (
            this.patTxSettingsForm.get(param).value == null ||
            this.patientData.customer.clinicTxSettings[param] == null
        ) {
            return false;
        } else {
            return true;
        }
    }
    isbackActivated: boolean = false;
    backButtonClick() {
        this.isbackActivated = true;
        this.onSaveButtonClick(true);
        // this.navBackward.emit('back');
    }

    cancelButtonClick() {
        this.router.navigate(['/patient-list']);
    }

    testDisplay() {
        return true;
    }

    testEnable() {
        return false;
    }

    enrollmentMode() {
        if (this.functionMode == 'enroll') {
            return true;
        } else {
            return false;
        }
    }

    profileMode() {
        if (this.functionMode == 'profile') {
            return true;
        } else {
            return false;
        }
    }

    editMode() {
        if (this.displayMode == 'edit') {
            return true;
        } else {
            return false;
        }
    }

    viewAndEnrollMode() {
        if (this.displayMode == 'edit' || this.functionMode == 'enroll') {
            return false;
        } else {
            return true;
        }
    }

    viewMode() {
        if (this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }

    setInitialValidator(){
        const response = this.originalData;
        const followupMode = this.followupScheduleForm.get('schedulingMethodCd').value;
        let permScheduleForm = (
            this.followupScheduleForm.get('smartSchedule') as UntypedFormGroup
        ).get('permSchedule') as UntypedFormGroup;
        permScheduleForm.get('startDate').setErrors({invalid: false})
        permScheduleForm.get('startDate').updateValueAndValidity();
        if(['enroll', 'profile'].includes(this.functionMode)){  // enroll
            if(followupMode == 509){
                if(response.smartSchedule.permSchedule.calculateFlg.toString() == 'true'){
                    if(permScheduleForm.get('startDate').value == ""){
                        permScheduleForm.get('startDate').setErrors({invalid: true})
                        permScheduleForm.get('startDate').updateValueAndValidity();
                        permScheduleForm.get('startDate').markAsDirty();
                    }
                }
            }
            if(followupMode == 510){  //manual
                const manualScheduleForm = this.followupScheduleForm.get('discSchedule') as UntypedFormGroup;
                const discDates = manualScheduleForm.get("discreteDates") as UntypedFormArray;
                if(discDates?.at(0)?.get('date').value == ''){
                    discDates?.at(0)?.get('date')?.setErrors({invalid: true});
                    discDates?.at(0)?.get('date')?.updateValueAndValidity();
                    discDates?.at(0)?.get('date')?.markAsDirty();
                }

            }
        }
    }

    setDisplayMode(value: string) {
        this.displayMode = value;
        if (value == 'view' && this.functionMode === 'profile') {
            this.followupScheduleForm.disable({emitEvent: false});
        }else{
            this.followupScheduleForm.enable({ emitEvent: false });
        }
        //  let mode = value == 'view' ? true : false;

        this.makeEnableDateControl(
            (this.followupScheduleForm.get('discSchedule') as UntypedFormGroup).get(
                'discreteDates'
            ) as UntypedFormArray,
            value
        );

        if (value == 'edit') {
            let smartScheduleForm = this.followupScheduleForm.get(
                'smartSchedule'
            ) as UntypedFormGroup;
            (smartScheduleForm.get('permSchedule') as UntypedFormGroup).enable();
            (smartScheduleForm.get('tempSchedule') as UntypedFormGroup).enable();
            (smartScheduleForm.get('tempEnabledFlg') as UntypedFormGroup).enable();

            let permScheduleForm = (
                this.followupScheduleForm.get('smartSchedule') as UntypedFormGroup
            ).get('permSchedule') as UntypedFormGroup;
            const response = this.originalData;
            if (response.smartSchedule.permSchedule.calculateFlg.toString() == 'false') {
                permScheduleForm.get('startDate').disable();
                permScheduleForm.get('transmitOnWeekCd').enable();
                permScheduleForm.get('transmitOnDayCd').enable();
                permScheduleForm.get('transmitOnMonthCd').enable();

                permScheduleForm.get('startDate').clearValidators();
                permScheduleForm
                    .get('transmitOnWeekCd')
                    .setValidators([Validators.required]);
                permScheduleForm
                    .get('transmitOnDayCd')
                    .setValidators([Validators.required]);
                permScheduleForm
                    .get('transmitOnMonthCd')
                    .setValidators([Validators.required]);
                permScheduleForm.get('startDate').updateValueAndValidity();
            } else {
                permScheduleForm.get('startDate').enable();
                permScheduleForm.get('transmitOnWeekCd').disable();
                permScheduleForm.get('transmitOnDayCd').disable();
                permScheduleForm.get('transmitOnMonthCd').disable();

                permScheduleForm
                    .get('startDate')
                    .setValidators([Validators.required]);
                permScheduleForm.get('transmitOnWeekCd').clearValidators();
                permScheduleForm.get('transmitOnDayCd').clearValidators();
                permScheduleForm.get('transmitOnMonthCd').clearValidators();
                permScheduleForm.get('startDate').updateValueAndValidity();
            }
            if (!response.smartSchedule.tempEnabledFlg) {
                (
                    (
                        this.followupScheduleForm.get(
                            'smartSchedule'
                        ) as UntypedFormGroup
                    ).get('tempSchedule') as UntypedFormGroup
                ).disable();
            } else {
                if (response.smartSchedule.tempSchedule.calculateFlg.toString() == 'true') {
                    let tmpScheduleForm = (
                        this.followupScheduleForm.get(
                            'smartSchedule'
                        ) as UntypedFormGroup
                    ).get('tempSchedule') as UntypedFormGroup;
                    tmpScheduleForm.get('transmitOnDayCd').disable();
                    tmpScheduleForm.get('transmitOnMonthCd').disable();
                    tmpScheduleForm.get('transmitOnWeekCd').disable();

                    tmpScheduleForm
                        .get('startDate')
                        .setValidators([Validators.required]);
                    tmpScheduleForm.get('startDate').updateValueAndValidity();
                } else {
                    let tmpScheduleForm = (
                        this.followupScheduleForm.get(
                            'smartSchedule'
                        ) as UntypedFormGroup
                    ).get('tempSchedule') as UntypedFormGroup;
                    tmpScheduleForm.get('startDate').disable();

                    tmpScheduleForm.get('startDate').clearValidators();
                    tmpScheduleForm.get('startDate').updateValueAndValidity();
                    tmpScheduleForm
                        .get('transmitOnDayCd')
                        .setValidators([Validators.required]);
                    tmpScheduleForm
                        .get('transmitOnMonthCd')
                        .setValidators([Validators.required]);
                    tmpScheduleForm
                        .get('transmitOnWeekCd')
                        .setValidators([Validators.required]);
                    tmpScheduleForm
                        .get('transmitOnDayCd')
                        .updateValueAndValidity();
                    tmpScheduleForm
                        .get('transmitOnMonthCd')
                        .updateValueAndValidity();
                    tmpScheduleForm
                        .get('transmitOnWeekCd')
                        .updateValueAndValidity();
                }
            }
            if (response.patient.patDevice.deviceType == 'ICM') {
                permScheduleForm.get('durationCd').setValue(1169);
                permScheduleForm.get('durationCd').disable();
            }
        //    this.setInitialValidator();
         //   this.followupScheduleForm.markAsPristine();
        }
    }

    cancelEditClick() {
        this.toastService.clear();
        if (this.followupScheduleForm.dirty) {
            this.clearFormArray(
                (
                    this.followupScheduleForm.get(
                        'discSchedule'
                    ) as UntypedFormGroup
                ).get('discreteDates') as UntypedFormArray
            );
            this.getData();
            this.setDisplayMode('view');
            this.enrollService.updateDeviceFormDirty(false);
            this.followupScheduleForm.markAsPristine();
        } else {
            this.setDisplayMode('view');
            this.clearFormArray(
                (
                    this.followupScheduleForm.get('discSchedule') as UntypedFormGroup
                ).get('discreteDates') as UntypedFormArray
            );
            this.getData();
            this.enrollService.updateDeviceFormDirty(false);
        }
    }

    viewModeDisable() {
        if (this.displayMode == 'view' && this.functionMode == 'profile') {
            return true;
        } else {
            return false;
        }
    }

    viewScheduleLink() {
        //&& this.followupScheduleForm.get('schedulingMethodCd').value  != '511'
        if (this.functionMode == 'profile') {
            return this.followupScheduleForm.get('schedulingMethodCd').value != 511;
        } else {
            return false;
        }
    }
    isViewScheduleCall: boolean = false;
    openViewScheduleDialog() {
        if (this.followupScheduleForm.dirty && this.displayMode != 'view') {
            const dialogConfig: PopupConfig = {
                type: PopupType.Confirm,
                message: this.localizationService.generateLocalizedStr(
                    'msg.cm817.text',
                    null,
                    'html'
                ),
                confirmText:
                    this.localizationService.generateLocalizedStr(
                        'label.gb.ok'
                    ),
                confirmId: this.identifierService.buttonId(
                    'pcs-location-popup',
                    'Ok'
                ),
                cancelId: this.identifierService.buttonId(
                    'pcs-location-popup',
                    'cancel001'
                ),
                cancelText: this.localizationService.generateLocalizedStr(
                    'label.gb.button_cancel'
                ),
                customPopup: true,
            };
            this.popupService.open(dialogConfig);
            this.popupService.dialogRef
                .afterClosed()
                .subscribe((response: any) => {
                    if (response) {
                        this.isViewScheduleCall = true;
                        this.saveData(false);
                    }
                });
        } else {
            this.isViewScheduleCall = false;
            // this.userProfileSubscription = this.userService
            //     .getUserObs()
            //     .subscribe((userData: UserProfileObject) => {
            //         if (userData) {
            //             this.dialog.open(ViewPrintFollowupComponent, {
            //                 width: '1000px',
            //                 data: {
            //                     id: this.patiendIdToSearch,
            //                 },
            //             }).afterClosed().subscribe((res)=>{

            //             });
            //         } else {
            //             this.userProfileSubscription = this.userService.getUserProfile(false)
            //                 .subscribe((userProfile: UserProfileObject) => {
            //                     this.dialog.open(ViewPrintFollowupComponent, {
            //                         width: '1000px',
            //                         data: {
            //                             id: this.patiendIdToSearch,
            //                         },
            //                     });
            //                 })
            //         }
            //     })
            this.dialog.open(ViewPrintFollowupComponent, {
                width: '1000px',
                data: {
                    id: this.patiendIdToSearch,
                    scheduleTypeCd: this.followupScheduleForm.get('schedulingMethodCd').value
                },
            }).afterClosed().subscribe((res) => {

            });
        }
    }

    ngOnDestroy(): void {
        //  this.userProfileSubscription?.unsubscribe();
        this.isActiveStep = false;
        this.resetErrors();
    }

    emptyPermStartDate() {
        if (this.functionMode == 'profile' && this.displayMode == 'edit') {
            this.patientData.smartSchedule.permSchedule.startDate = '';
            this.formValidators['perm.startDate'].markAsUntouched();
        }
        if (this.functionMode == 'enroll') {
            this.patientData.smartSchedule.permSchedule.startDate = '';
            this.formValidators['perm.startDate'].markAsUntouched();
        }
    }

    emptyPermDropDowns() {
        if (this.functionMode == 'profile' && this.displayMode == 'edit') {
            this.patientData.smartSchedule.permSchedule.transmitOnWeekCd = '';
            this.patientData.smartSchedule.permSchedule.transmitOnDayCd = '';
            this.patientData.smartSchedule.permSchedule.transmitOnMonthCd = '';
            this.formValidators['perm.transmitOnDayCd'].markAsUntouched();
            this.formValidators['perm.transmitOnWeekCd'].markAsUntouched();
            this.formValidators['perm.transmitOnMonthCd'].markAsUntouched();
        }
        if (this.functionMode == 'enroll') {
            this.patientData.smartSchedule.permSchedule.transmitOnWeekCd = '';
            this.patientData.smartSchedule.permSchedule.transmitOnDayCd = '';
            this.patientData.smartSchedule.permSchedule.transmitOnMonthCd = '';
            this.formValidators['perm.transmitOnDayCd'].markAsUntouched();
            this.formValidators['perm.transmitOnWeekCd'].markAsUntouched();
            this.formValidators['perm.transmitOnMonthCd'].markAsUntouched();
        }
    }

    emptyTempStartDate() {
        if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit' &&
            this.patientData.smartSchedule.tempEnabledFlg
        ) {
            this.patientData.smartSchedule.tempSchedule.startDate = '';
            this.formValidators['temp.startDate'].markAsUntouched();
        }
        if (
            this.functionMode == 'enroll' &&
            this.patientData.smartSchedule.tempEnabledFlg
        ) {
            this.patientData.smartSchedule.tempSchedule.startDate = '';
            this.formValidators['temp.startDate'].markAsUntouched();
        }
    }

    emptyTempDropDowns() {
        if (this.functionMode == 'profile' && this.displayMode == 'edit') {
            this.patientData.smartSchedule.tempSchedule.transmitOnWeekCd = '';
            this.patientData.smartSchedule.tempSchedule.transmitOnDayCd = '';
            this.patientData.smartSchedule.tempSchedule.transmitOnMonthCd = '';
            this.formValidators['temp.transmitOnDayCd'].markAsUntouched();
            this.formValidators['temp.transmitOnWeekCd'].markAsUntouched();
            this.formValidators['temp.transmitOnMonthCd'].markAsUntouched();
        }
        if (this.functionMode == 'enroll') {
            this.patientData.smartSchedule.tempSchedule.transmitOnWeekCd = '';
            this.patientData.smartSchedule.tempSchedule.transmitOnDayCd = '';
            this.patientData.smartSchedule.tempSchedule.transmitOnMonthCd = '';
            this.formValidators['temp.transmitOnDayCd'].markAsUntouched();
            this.formValidators['temp.transmitOnWeekCd'].markAsUntouched();
            this.formValidators['temp.transmitOnMonthCd'].markAsUntouched();
        }
    }

    removeOverridesClick() {
        // this.dataToSend = JSON.parse(JSON.stringify(this.originalData));
        // this.dataToSend.patTxSettings = JSON.parse(
        //     JSON.stringify(this.dataToSend.customer.clinicTxSettings)
        // );
        // this.updateData(false);
        this.patTxSettingsForm.patchValue({
            clearEgmsFlg: this.patientData.customer.clinicTxSettings.clearEgmsFlg,
            clearStatsDiagnosticsFlg: this.patientData.customer.clinicTxSettings.clearStatsDiagnosticsFlg,
            clearEpisodalDiagnosticsFlg: this.patientData.customer.clinicTxSettings.clearEpisodalDiagnosticsFlg,
            clearEpisodeEgmDiagFlg: this.patientData.customer.clinicTxSettings.clearEpisodeEgmDiagFlg,
            clearStMonitorFlg: this.patientData.customer.clinicTxSettings.clearStMonitorFlg,
            clearEpisInclEgmFlg: this.patientData.customer.clinicTxSettings.clearEpisInclEgmFlg,
            clearDiagFlg: this.patientData.customer.clinicTxSettings.clearDiagFlg,
            //clearStatsDiagnosticsFlg:  this.patientData.customer.clinicTxSettings.clearStatsDiagnosticsFlg
        })
        this.patTxSettingsForm.markAsDirty();
    }

    showRemoveOverrides() {
        let patTx = this.patientData.patTxSettings;
        let clinicTx = this.patientData.customer.clinicTxSettings;
        if (this.functionMode == 'enroll') {
            return false;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'view'
        ) {
            return false;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit' &&
            this.compareObjects(patTx, clinicTx)
        ) {
            return false;
        } else {
            return true;
        }
    }
    releasePatient() {
        if (this.hasPatientDataEntryAccess) {
            const patientIds = [+this.patiendIdToSearch];

            this.patientListService.getReleasePatientData(patientIds).subscribe(
                (res) => {
                    const releasePatientDRef = this.dialog.open(
                        ReleasePatientDialogComponent,
                        {
                            width: '900px',
                            // height:'600px',
                            data: {
                                patients: res.releasePatientSummaryDTO.map(
                                    (a) => {
                                        a.patientInfo[
                                            'isTransmissionComplete'
                                        ] = a.isTransmissionComplete;
                                        return a.patientInfo;
                                    }
                                ),
                                clinicFavoriteDTO: res.clinicFavoriteDTO,
                                releaseReasonCd: res.releaseReasonCd,
                                transferCustApplId: res.transferCustApplId,
                            },
                        }
                    );

                    releasePatientDRef.afterClosed().subscribe((result) => {

                        if (result.reasonForReasonFlag) {
                            const selectedIds = [this.patiendIdToSearch];
                            let data = {
                                patientIds: selectedIds,
                                releaseReasonCode: result.reasonForReasonFlag,
                                transferCustApplId: result.transferCustApplId
                                    ? result.transferCustApplId
                                    : '',
                            };
                            this.patientListService
                                .updateReleasePatient(data)
                                .subscribe((response) => {
                                    const refTransferCusDetails =
                                        res.clinicFavoriteDTO &&
                                        res.clinicFavoriteDTO.find(
                                            (a) =>
                                                a.associatedCustApplId ===
                                                result.transferCustApplId
                                        );
                                    let releasePatient =
                                        this.translateService.instant(
                                            'msg.pa834b.text'
                                        );

                                    if (refTransferCusDetails) {
                                        releasePatient += ` ${refTransferCusDetails.name} : ${refTransferCusDetails.phoneNum} `;
                                    }
                                    if (result.reasonForReasonFlag === 'R' &&
                                        result.selectedClinicDetails) {
                                    const phone = `${result.selectedClinicDetails.countryCode}-${result.selectedClinicDetails.areaCode}-${result.selectedClinicDetails.phoneNum}`;
                                    const releaseTxt =  this.activatorClinicFlg ? 'msg.patrel_actclinic.text' : 'msg.patrel_regclinic.text';
                                        releasePatient = result.selectedClinicDetails.customerId !=null
                                         ?
                                         this.translateMsg( releaseTxt,
                                            {
                                                0: result.selectedClinicDetails.name,
                                                1: phone,
                                            }, ReturnType.HTML
                                        ) : this.translateMsg('msg.pa834a.text', null, ReturnType.HTML);

                                        this.isPatientRelease = true;
                                        this.releasePatientMsg = releasePatient;

                                } else{
                                    this.isPatientRelease = false;
                                    this.releasePatientMsg = '';
                                }

                                    if (this.profileMode()) {
                                        this.toastrSer.success(this.localizationService.generateLocalizedStr('msg.pa834b.text'));
                                    }
                                });
                        }
                    });
                },
                (err) => {
                    this.helperService.showErrorToastr(err);
                }
            );
        }
    }
    // translate(key: string): any {
    //     return this.translateService.instant(key);
    // }
    translateMsg(key, params, returnType) {
        return this.localizationService.generateLocalizedStr(
            key,
            params,
            returnType
        );
    }

    persistence(num) {
        var numArray = num.split('');
        var lastIndex = numArray.length - 1;
        if (numArray[lastIndex] == 'd') {
            numArray.pop();
            return Number(numArray.join(''));
        } else if (numArray[lastIndex] == 'W') {
            numArray.pop();
            return Number(numArray.join('')) * 7;
        } else if (numArray[lastIndex] == 'M') {
            numArray.pop();
            return Number(numArray.join('')) * 30;
        }
    }

    getFrequencyDays(frequencyCd) {
        let days = this.patientData.codes.permSchdFrequencyCodes.filter(
            (d: any) => {
                return d.codeId == frequencyCd;
            }
        );
        let actualFreq = this.persistence(days[0].code);
        return actualFreq * 1.5;
    }

    getFrequencyDaysForTempSchedule(frequencyCd) {
        let days = this.patientData.codes.tempSchdFrequencyCodes.filter(
            (d: any) => {
                return d.codeId == frequencyCd;
            }
        );
        let actualFreq = this.persistence(days[0].code);
        return actualFreq * 1.5;
    }

    validateSmartStartDate(): boolean {
        const monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        const rawData = this.followupScheduleForm.getRawValue();
        if (rawData.smartSchedule.tempEnabledFlg) {
            let tempStartDate;
            let permStartDate;

            if (rawData.smartSchedule.permSchedule.calculateFlg.toString() == 'true') {
                permStartDate = rawData.smartSchedule.permSchedule.startDate;
            } else {
                permStartDate = this.getDateFromDropDown(monthNames, rawData.smartSchedule.permSchedule);
            }
            if (rawData.smartSchedule.tempSchedule.calculateFlg.toString() == 'true') {
                tempStartDate = rawData.smartSchedule.tempSchedule.startDate;
            } else {
                tempStartDate = this.getDateFromDropDown(monthNames, rawData.smartSchedule.tempSchedule);
            }
            if (moment(permStartDate).isAfter(moment(tempStartDate))) {
                return this.getCalculation(rawData.smartSchedule, rawData.smartSchedule.tempSchedule, true);
            } else {
                return this.getCalculation(rawData.smartSchedule, rawData.smartSchedule.permSchedule, false);
            }
        } else {
            return this.getCalculation(rawData.smartSchedule, rawData.smartSchedule.permSchedule, false);
        }
        return true;
    }

    diffGreaterThanYear = false;
    getCalculation(smartSchedule, specificSchedule, isTemp) {
        this.diffGreaterThanYear = false;
        const monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        if (
            specificSchedule.calculateFlg == 'true' ||
            specificSchedule.calculateFlg == true
        ) {
            const date1 = this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ);
            const date2 = new Date(
                specificSchedule.startDate
            );
            const diffTime = Math.abs(Number(date2) - Number(date1));
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            let findGap = isTemp ? this.getFrequencyDaysForTempSchedule(specificSchedule.frequencyCd) : this.getFrequencyDays(specificSchedule.frequencyCd);

            this.diffGreaterThanYear = diffDays > 364;
            return diffDays > 364 ? true : diffDays < findGap;
        } else {
            let d2 = this.getDateFromDropDown(monthNames, specificSchedule);
            const date1 = this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ);
            const diffTime = Math.abs(Number(new Date(d2)) - Number(date1));
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            let findGap = isTemp ? this.getFrequencyDaysForTempSchedule(specificSchedule.frequencyCd) : this.getFrequencyDays(specificSchedule.frequencyCd);
            this.diffGreaterThanYear = diffDays > 364;
            return diffDays > 364 ? true : diffDays < findGap;
        }
    }

    getDateFromDropDown(monthNames: string[], specificSchedule: any): Date | string {
        const d = this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ);
        const arrayIndx = d.getMonth();

        const selectedMonth =
            this.patientData.codes.transmitMonthCodes.filter(
                (month: any) => {
                    return (specificSchedule.transmitOnMonthCd ==
                        month.codeId);
                }
            )[0].description;
        const currentMonthIndex = monthNames.indexOf(selectedMonth);
        let year = (currentMonthIndex < arrayIndx) ? this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ).getFullYear() + 1 : this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ).getFullYear();
        let week = specificSchedule.transmitOnWeekCd - 916;
        let dY = specificSchedule.transmitOnDayCd == 275 ? 1 : specificSchedule.transmitOnDayCd - 267;
        return this.getDateByNthWeekDay(week, dY, (currentMonthIndex + 1), year);
    }

    getDateByNthWeekDay(nthWeekday, weekday, month, year) {
        const firstDayofMonth = new Date(year, month - 1, 1);
        let firstOccurance = new Date(firstDayofMonth);
        while (firstOccurance.getDay() !== (weekday - 1)) {
            firstOccurance.setDate(firstOccurance.getDate() + 1);
        }
        firstOccurance.setDate(firstOccurance.getDate() + 7 * (nthWeekday - 1));
        return firstOccurance.toISOString()
    }

    getDialogRef(key): PopupConfig {
        const dialogConfig: PopupConfig = {
            type: PopupType.Confirm,
            message: this.localizationService.generateLocalizedStr(
                key,
                null,
                'html'
            ),
            confirmText:
                this.localizationService.generateLocalizedStr('label.gb.ok'),
            confirmId: this.identifierService.buttonId(
                'pcs-location-popup',
                'Ok'
            ),
            cancelId: this.identifierService.buttonId(
                'pcs-location-popup',
                'cancel001'
            ),
            cancelText: this.localizationService.generateLocalizedStr(
                'label.gb.button_cancel'
            ),
            customPopup: true,
        };
        return dialogConfig;
    }
    // isLessThan7days(): boolean {
    //     const rawData = this.followupScheduleForm.getRawValue();
    //     const date1 = this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ);
    //     const date2 = new Date(rawData.smartSchedule.permSchedule.startDate);
    //     const diffTime = Math.abs(Number(date2) - Number(date1));
    //     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    //     return diffDays <= 7;
    // }

    isLessThan7days(): boolean {
        const monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        const rawData = this.followupScheduleForm.getRawValue();
        const date1 = new Date();
        let startDate;
        if (rawData.schedulingMethodCd == '509') {

            if (rawData.smartSchedule.tempEnabledFlg) {
                let tempStartDate;
                let permStartDate;

                if (rawData.smartSchedule.permSchedule.calculateFlg.toString() == 'true') {
                    permStartDate = rawData.smartSchedule.permSchedule.startDate;
                } else {
                    permStartDate = this.getDateFromDropDown(monthNames, rawData.smartSchedule.permSchedule);
                }
                if (rawData.smartSchedule.tempSchedule.calculateFlg.toString() == 'true') {
                    tempStartDate = rawData.smartSchedule.tempSchedule.startDate;
                } else {
                    tempStartDate = this.getDateFromDropDown(monthNames, rawData.smartSchedule.tempSchedule);
                }
                if (moment(permStartDate).isAfter(moment(tempStartDate))) {
                    startDate = tempStartDate;
                } else {
                    startDate = permStartDate;
                }
            } else {
                if (rawData.smartSchedule.permSchedule.calculateFlg.toString() == 'true') {
                    startDate = rawData.smartSchedule.permSchedule.startDate;
                } else {
                    startDate = this.getDateFromDropDown(monthNames, rawData.smartSchedule.permSchedule);
                }
            }
        } else {
            let dates = rawData.discSchedule.discreteDates.filter((item) => {
                return ![null, ''].includes(item.date);
            }).sort((a, b) => {
                return moment(a.date).isAfter(moment(b.date)) ? 0 : -1;
            })
            startDate = dates[0].date;
        }
        const date2 = new Date(startDate);
        const diffTime = Math.abs(Number(date2) - Number(date1));
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays <= 7;
    }

    isLessThan7daysManual(): boolean {
        const rawData = this.followupScheduleForm.getRawValue();
        const date1 = this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ);
        let lessThan7Days = false;

        rawData.discSchedule.discreteDates.forEach(element => {
            if (element.date?._d) {
                const date2 = new Date(element.date?._d);
                const diffTime = Math.abs(Number(date2) - Number(date1));
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                if (diffDays <= 7) {
                    lessThan7Days = true;
                    return;
                }
            }
        });

        return lessThan7Days;
    }

    isLessThan7daysTempDate(): boolean {
        const rawData = this.followupScheduleForm.getRawValue();
        const date1 = this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ);
        const date2 = new Date(rawData.smartSchedule.tempSchedule.startDate);
        const diffTime = Math.abs(Number(date2) - Number(date1));
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays <= 7;
    }

    isDateMoreThanOneYearAway(inputDate: any): boolean {
        const targetDate = new Date(inputDate);
        const currentDate = this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ);
        const timeDifference = targetDate.getTime() - currentDate.getTime();
        const oneYearInMilliseconds = 365 * 24 * 60 * 60 * 1000;
        return Math.abs(timeDifference) > oneYearInMilliseconds;
    }

    isManualInductiveNeedtoShow: boolean = false;
    saveData(navAway: boolean) {
        let sendData = false;
        // copy array
        this.dataToSend = JSON.parse(JSON.stringify(this.patientData));
        const smartScheduleForm = this.followupScheduleForm.get(
            'smartSchedule'
        ) as UntypedFormGroup;
        const smartScheduleRawData = smartScheduleForm.getRawValue();
        if (
            this.followupScheduleForm.get('schedulingMethodCd').value == 509 &&
            this.followupScheduleForm.dirty
        ) {
            const smartScheduleForm = this.followupScheduleForm.get('smartSchedule') as UntypedFormGroup;
            const permSchedule = smartScheduleForm.get('permSchedule') as UntypedFormGroup;
            let tempScheduleForm = smartScheduleForm.get('tempSchedule') as UntypedFormGroup;
            const calcFlg = smartScheduleForm.get('tempEnabledFlg').value == true ? tempScheduleForm.get('calculateFlg').value : permSchedule.get('calculateFlg').value;
            //  this.resetErrors();

            const startDateInValid = smartScheduleForm.get('tempEnabledFlg').value == true ? !tempScheduleForm.get('startDate').value : !permSchedule.get('startDate').value

            if (smartScheduleForm.valid && (!startDateInValid || calcFlg?.toString() === 'false')) {

                let isDateSelectionValid = 0;
                let tempScheduleInvalid = false;
                let permScheduleInvalid = false;
                if (
                    smartScheduleRawData.permSchedule.calculateFlg.toString() == 'true' &&
                    smartScheduleRawData.permSchedule.schdChangedFlg
                ) {
                    const momentDate = smartScheduleRawData.permSchedule.startDate._isAMomentObject ?
                        this.helperService.getDateWithoutTime(new Date(smartScheduleRawData.permSchedule.startDate.format('YYYY-MM-DDTHH:mm:ss'))) : null;

                    if (
                        momentDate &&
                        (this.helperService.getDateWithoutTime(this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ)) >=
                            momentDate)
                        ||
                        this.isDateMoreThanOneYearAway(smartScheduleRawData.permSchedule.startDate)
                    ) {
                        permScheduleInvalid = true;
                        isDateSelectionValid++;
                    }
                }
                if (smartScheduleRawData.tempEnabledFlg) {
                    if (
                        smartScheduleRawData.tempSchedule.calculateFlg.toString() == 'true' &&
                        smartScheduleRawData.tempSchedule.schdChangedFlg
                    ) {
                        const momentDate = smartScheduleRawData.tempSchedule.startDate._isAMomentObject ?
                            this.helperService.getDateWithoutTime(new Date(smartScheduleRawData.tempSchedule.startDate.format('YYYY-MM-DDTHH:mm:ss'))) : null;
                        if (
                            momentDate &&
                            (this.helperService.getDateWithoutTime(this.helperService.getCurrentDateByTimeZone(this.userProfData?.clinicUserTZ)) >=
                                momentDate)
                            ||
                            this.isDateMoreThanOneYearAway(smartScheduleRawData.tempSchedule.startDate)
                        ) {
                            tempScheduleInvalid = true;
                            isDateSelectionValid++;
                        }
                    }
                }
                if (isDateSelectionValid == 0) {

                    if (this.validateSmartStartDate()) {
                        if (this.deviceInductive && !this.directCallFlg && !this.diffGreaterThanYear) {
                            const alertMsg = this.localizationService.generateLocalizedStr('msg.pa864.text');
                            const dialogConfig = this.getAlertDialogRef(alertMsg);
                            this.popupService.open(dialogConfig);
                            this.popupService.dialogRef
                                .afterClosed()
                                .subscribe((response: any) => {
                                    if (response) {
                                        //  this.isManualInductiveNeedtoShow = false;
                                        this.updateData(navAway);
                                    }
                                });
                        } else {
                            if (this.isLessThan7days() && (this.originalData?.patient?.patDevice?.deviceType != "NGQ")
                                && (this.originalData?.patient?.patDevice?.deviceType != "ICM")) {
                                const dialogConfig =
                                    this.getDialogRef('msg.pa857a.text');
                                this.popupService.open(dialogConfig);
                                this.popupService.dialogRef
                                    .afterClosed()
                                    .subscribe((response: any) => {
                                        if (response) {
                                            this.updateData(navAway);
                                        }
                                    });
                            } else {
                                this.updateData(navAway);
                            }
                        }
                    } else {

                        const dialogConfig =
                            this.getDialogRef('msg.pa856a.text');
                        this.popupService.open(dialogConfig);
                        this.popupService.dialogRef
                            .afterClosed()
                            .subscribe((response: any) => {
                                if (response) {
                                    if (this.deviceInductive && !this.directCallFlg && !this.diffGreaterThanYear) {
                                        smartScheduleForm.get('permSchedule').get('startDate').setErrors({ invalid: true })
                                        smartScheduleForm.get('permSchedule').get('startDate').updateValueAndValidity();

                                        const alertMsg = this.localizationService.generateLocalizedStr('msg.pa864.text');
                                        const dialogConfig = this.getAlertDialogRef(alertMsg);
                                        this.popupService.open(dialogConfig);
                                        this.popupService.dialogRef
                                            .afterClosed()
                                            .subscribe((response: any) => {
                                                if (response) {
                                                    this.updateData(navAway);
                                                }
                                            });
                                    } else {
                                        this.updateData(navAway);
                                    }
                                }
                            });
                        //   }
                    }
                    //  }
                } else {
                    if (
                        smartScheduleRawData.permSchedule.calculateFlg.toString() == 'true' &&
                        smartScheduleRawData.permSchedule.schdChangedFlg &&
                        permScheduleInvalid
                    ) {
                        smartScheduleForm.get('permSchedule').get('startDate').setErrors({ invalid: true })
                    }

                    if (smartScheduleRawData.tempEnabledFlg) {
                        if (
                            smartScheduleRawData.tempSchedule.calculateFlg.toString() == 'true' &&
                            smartScheduleRawData.tempSchedule.schdChangedFlg &&
                            tempScheduleInvalid
                        ) {
                            smartScheduleForm.get('tempSchedule').get('startDate').setErrors({ invalid: true })
                        }
                    }
                    const errorMsg =
                        this.localizationService.generateLocalizedStr(
                            'msg.pa860.text',
                            { '0': 12 },
                            'html'
                        );
                    this.toastRef = this.toastService.error(errorMsg, null, {
                        enableHtml: true,
                        disableTimeOut: true,
                    });
                }
            } else {

                const field =
                    this.localizationService.generateLocalizedStr(
                        'label.gb.starting_on'
                    );
                let errorMsg = this.localizationService.generateLocalizedStr('msg.cs816.text');

                let smartScheduleForm = this.followupScheduleForm.get('smartSchedule') as UntypedFormGroup;
                let permScheduleForm = smartScheduleForm.get('permSchedule') as UntypedFormGroup;
                let tempScheduleForm = smartScheduleForm.get('tempSchedule') as UntypedFormGroup;
                let errorFields = [];
                for (let control in permScheduleForm.controls) {

                    if (permScheduleForm.get(control).errors?.required) {
                        if (!errorFields.includes(control)) {
                            errorFields.push(control)
                        }
                    }
                    if (tempScheduleForm.get(control).errors?.required) {
                        if (!errorFields.includes(control)) {
                            errorFields.push(control)
                        }
                    }
                }
                const reqerrorMsg = this.localizationService.generateLocalizedStr(
                    'msg.pa861.text',
                    null,
                    'html'
                );
                if (!permSchedule.get('startDate').value && errorFields.length === 0) {

                    errorFields.push(permSchedule.get('startDate'))
                }
                if (!tempScheduleForm.get('startDate').value && errorFields.length === 0) {

                    errorFields.push(tempScheduleForm.get('startDate'))
                }

                if (smartScheduleForm.get('tempEnabledFlg').value == true) {
                    tempScheduleForm.get('startDate').markAsTouched();
                    tempScheduleForm.get('startDate').updateValueAndValidity();
                }
                else {
                    permScheduleForm.get('startDate').markAsTouched();
                    permSchedule.get('startDate').updateValueAndValidity();
                }

                if (errorFields.length > 1) {

                    if (smartScheduleRawData.tempEnabledFlg) {
                        if (smartScheduleRawData.tempSchedule.calculateFlg.toString() == 'true' && !smartScheduleForm.get('tempSchedule').get('startDate').value) {
                            smartScheduleForm.get('tempSchedule').get('startDate').markAsTouched()
                            smartScheduleForm.get('tempSchedule').get('startDate').setErrors({ invalid: true })
                            // this.smartFollowUpComponent.setOnCallDropdownError(true);
                        }
                    }
                    if (smartScheduleRawData.permSchedule.calculateFlg.toString() == 'true' && !smartScheduleForm.get('permSchedule').get('startDate').value) {
                        smartScheduleForm.get('permSchedule').get('startDate').markAsTouched()
                        smartScheduleForm.get('permSchedule').get('startDate').setErrors({ invalid: true })
                        //this.smartFollowUpComponent.setOnCallDropdownError(true);
                    }


                    // smartScheduleForm.get('tempSchedule').markAllAsTouched();
                    // smartScheduleForm.get('permSchedule').markAllAsTouched();
                    if (smartScheduleForm.get('tempEnabledFlg').value == true) {
                        smartScheduleForm.get('tempSchedule').markAllAsTouched();
                    }
                    smartScheduleForm.get('permSchedule').markAllAsTouched();
                    this.toastRef = this.toastService.show(reqerrorMsg, null, {
                        enableHtml: true,
                        disableTimeOut: true,
                        timeOut: 0,
                        extendedTimeOut: 0,
                        tapToDismiss: false,
                        closeButton: true,
                        toastClass: `${ToasterClass.userNotificationMessageA} ${ToasterClass.ngxToastr}`,
                    });
                } else {



                    if ((this.permStartDateString != "" && typeof this.permStartDateString != 'undefined' && [null, ""].includes(smartScheduleRawData.permSchedule.startDate))
                        || (this.tempStartDateString != "" && typeof this.tempStartDateString != 'undefined' && [null, ""].includes(smartScheduleRawData.tempSchedule.startDate))) {
                        let msg = this.localizationService.generateLocalizedStr('msg.cs816.text', {'0': ''}, 'html');
                        let submsg = this.localizationService.generateLocalizedStr('msg.cs816.text_appendix', { '0': this.getDateLabel() }, 'html');
                        let errorMsg = this.helperService.getErrorList([msg,field,submsg]);
                        this.toastService.error(errorMsg, null, {
                            enableHtml: true,
                            disableTimeOut: true,
                        });
                    } else {
                        if (smartScheduleForm.get('tempEnabledFlg').value == true) {
                            tempScheduleForm.get('startDate').markAsTouched();
                            tempScheduleForm.markAllAsTouched();
                        }

                        permScheduleForm.markAllAsTouched();

                        this.toastService.error(reqerrorMsg, null, {
                            enableHtml: true,
                            disableTimeOut: true,
                        });
                    }
                }
            }
        } else {
            this.followupScheduleForm.markAsDirty();
            if (this.followupScheduleForm.get('schedulingMethodCd').value == 510 &&
                this.followupScheduleForm.dirty) {
                   //  this.setInitialValidator();
                this.isManualInductiveNeedtoShow = true;
                this.updateData(navAway);
            } else {
                this.updateData(navAway);
            }
        }
    }

    reActivatePatient() {
        if (this.hasPatientDataEntryAccess) {
            this.patientListService
                .updateReactivatePatient([this.patiendIdToSearch])
                .subscribe(
                    (res) => {
                        this.toastrSer.success(
                            this.localizationService.generateLocalizedStr('msg.pa800b.text', { 0: '1' })
                        );
                        this.isPatientRelease = false;
                    },
                    (err) => {
                        this.helperService.showErrorToastr(err);
                    }
                );
        }
    }
    openPrintDialog() {
        const dialogRef = this.dialog.open(PatientProfilePrintDialogComponent, {
            data: {
                patientid: this.patiendIdToSearch,
                patRes: this.patRes,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {

        });
    }
    getPatRes() {

        this.enrollService
            .getDeviceData(this.functionMode, this.patiendIdToSearch.toString())
            .subscribe(
                (res) => {
                    this.patRes = res;
                    this.isAveirDevice = res?.patientDevices?.[0]?.isAveirDevice;
                    this.directCallFlg = res.clinicDetails?.msgReminderFlg;
                },
                (err) => {
                    console.log(err);
                }
            );
    }

    updateCheckboxState() {
        if (this.stDiagInclStEgmEnabled()) {
            this.patTxSettingsForm.get("clearStMonitorFlg")?.disable();
        }
        if (this.viewModeDisable()) {
            this.patTxSettingsForm.get("clearStatsDiagnosticsFlg")?.disable();
            this.patTxSettingsForm.get("clearEpisInclEgmFlg")?.disable();
            this.patTxSettingsForm.get("clearEpisodeEgmDiagFlg")?.disable();
            this.patTxSettingsForm.get("clearEpisodalDiagnosticsFlg")?.disable();
            this.patTxSettingsForm.get("clearDiagFlg")?.disable();
            this.patTxSettingsForm.get("clearEgmsFlg")?.disable();
        }
    }

    onPermStartDateChange(startDate: string) {
        this.permStartDateString = startDate;
    }

    onTempStartDateChange(startDate: string) {
        this.tempStartDateString = startDate;
    }
}
